import step1 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-1 Click Apps.png'
import step2 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-2 Create an app.png'
import step3 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-3 App overview.png'
import step4 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-4 Filled app details.png'
import step5 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-5 After create app.png'
import step6 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-6 App overview page.png'
import step7 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-7 Admin API Integration.png'
import step8 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-8 Grant required permissions.png'
import step9 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-9 Configuration saved pop-up.png'
import step10 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-10 API credentials page.png'
import step11 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-11 click install app.png'
import step12 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-12 Install app pop-up.png'
import step13 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-13 after Install app pop-up.png'
import step14 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-14 reveal access token page.png'
import step15 from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/CA-15 click reveal access token.png'
import shopDomain from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/Shop Domain.png'
import storeDetailsPage from '@wellbeingxltd/fe-lib/images/dist/supplier/instruction/Store Details Page.png'

export const getSteps = initialValues => [
    // Part - 1. How to Create a Custom App
    {
        step: 1,
        html: 'Log into your Shopify Admin and select <b>Apps</b> from the menu, Now click the <b>Develop apps</b>.',
        image: step1,
    },
    {
        step: 2,
        html: `After clicking the <b>Develop apps</b> button, you will be redirected to the following page.<br/>
        i.e. <b>App development</b>`,
        image: step2,
    },
    {
        step: 3,
        html: 'Now click on the <b>Create an app</b> button. After clicking the <b>Create an app</b> button, one pop-up will be displayed.',
        image: step3,
    },
    {
        step: 4,
        html: `In the modal window, enter the <b>App name</b> i.e. <b>Betterspace Client</b> and select an App developer. The app developer can be the store owner, or any staff or collaborator account with the Develop apps permission.<br/><br/>
        After filling in all the details, click the <b>Create app</b> button.`,
        image: step4,
    },
    {
        step: 5,
        html: `Now click on the <b>Create app</b> button. After clicking the <b>Create app</b> button, you will be redirected to the following page.<br/>
        i.e. <b>Overview page</b>`,
        image: step5,
    },
    // Part - 2. Select API scopes
    {
        html: `After you create a custom app, you can assign API scopes to it. A custom app can have <b>Admin API scopes</b>, <b>Storefront API scopes</b>, or both, depending on the requirements of the app.<br/><br/>
        In this custom app, we are going to configure only the <b>Admin API scopes</b>.`,
        image: step6,
    },
    {
        step: 6,
        html: `Now click on the <b>Configure Admin API scopes</b> button, After clicking the <b>Configure Admin API scopes</b> button, you will be redirected to the following page.<br/>
        i.e. Admin API integration`,
        image: step7,
    },
    {
        step: 7,
        html: `In the <b>Admin API access scopes</b> section, select the areas of your store that you want the app to be able to access.<br/><br/>

        In the <b>Admin API access scopes</b>, you can select the options you want your app to have access to. For example, you want your custom app to have access to your <b>Customers</b> You can do that by just finding <b>Customers</b> at the bottom of the list and select<br/> 
        <b>write_customers -> read_customers</b>. Simple as that!`,
        image: step8,
        textWithTable: {
            heading: 'Grant access to the following permissions.',
            table: (
                <table width="100%">
                    <tbody>
                        <tr>
                            <th align="left">Display name</th>
                            <th align="left">Scope name</th>
                            <th align="left">Access level</th>
                        </tr>
                        <tr>
                            <td>Assigned fulfillment orders</td>
                            <td>read_assigned_fulfillment_orders, write_assigned_fulfillment_orders</td>
                            <td>Read and write</td>
                        </tr>
                        <tr>
                            <td>Customers</td>
                            <td>read_customers,write_customers</td>
                            <td>Read and write</td>
                        </tr>
                        <tr>
                            <td>Discounts</td>
                            <td>read_discounts</td>
                            <td>Read</td>
                        </tr>
                        <tr>
                            <td>Draft orders</td>
                            <td>read_draft_orders, write_draft_orders</td>
                            <td>Read and write</td>
                        </tr>
                        <tr>
                            <td>Fulfilment services</td>
                            <td>read_fulfillments, write_fulfillments</td>
                            <td>Read and write</td>
                        </tr>
                        <tr>
                            <td>Inventory</td>
                            <td>read_inventory</td>
                            <td>Read</td>
                        </tr>
                        <tr>
                            <td>Order editing</td>
                            <td>read_order_edits, write_order_edits</td>
                            <td>Read and write</td>
                        </tr>
                        <tr>
                            <td>Orders</td>
                            <td>read_orders, write_orders</td>
                            <td>Read and write</td>
                        </tr>
                        <tr>
                            <td>Price rules</td>
                            <td>read_price_rules</td>
                            <td>Read</td>
                        </tr>
                        <tr>
                            <td>Product listings</td>
                            <td>read_product_listings</td>
                            <td>Read</td>
                        </tr>
                        <tr>
                            <td>Products</td>
                            <td>read_products</td>
                            <td>Read</td>
                        </tr>
                        <tr>
                            <td>Shipping</td>
                            <td>read_shipping, write_shipping</td>
                            <td>Read and write</td>
                        </tr>
                        <tr>
                            <td>Third-party fulfilment orders</td>
                            <td>read_third_party_fulfillment_orders, write_third_party_fulfillment_orders</td>
                            <td>Read and write</td>
                        </tr>
                    </tbody>
                </table>
            ),
        },
    },
    {
        step: 8,
        html: `Once you are done with assigning access scopes to the app, click the <b>Save</b> button.
        In the <b>Webhook subscriptions</b> section select the Event version as <b>Latest version</b><br/>
        After clicking the <b>Save</b> button, one pop-up will be displayed.`,
        image: step9,
    },
    {
        step: 9,
        html: `Now click on the <b>API credentials</b> button, After clicking the <b>API credentials</b> button, you will be redirected to the following page.<br/>
        i.e. API credentials`,
        image: step10,
    },
    // Part - 3. Install the app and get the API access tokens
    {
        text: `After you've set API scopes for your app, you can install the app. You'll get your API access tokens after you install. Depending on what API scopes you assigned to the app, you'll get an Admin API access token.`,
    },
    {
        step: 10,
        html: `Click the <b>Install app</b> button`,
        image: step11,
    },
    {
        step: 11,
        html: `When you click the <b>Install app</b> button, one pop-up will be displayed.
        <br/><br/>
        In the modal read and check the terms, and then click the <b>Install</b> button.`,
        image: step12,
    },
    {
        step: 12,
        text: 'You can see your newly created custom app',
        image: step13,
    },
    {
        step: 13,
        html: `In the <b>Admin API access token</b> section click the <b>Reveal token once</b> button`,
        image: step14,
    },
    {
        html: `When you click the <b>Reveal token once</b> button, you will get the admin api access token`,
        image: step15,
    },
    {
        step: 14,
        html: `Copy the <b>API key</b>, <b>Admin API access token</b> and <b>Store Domain</b> ( Store Name) and enter in Betterspace Supplier Dashboard.`,
        anotherTexts: [
            {
                html: `For the Store Domain, Follow the procedure.<br/>
                Please click on "Settings". -> After clicking on the settings, you will see the following page.`,
                image: storeDetailsPage,
            },
            {
                html: `At the top, left corner, you can see your shop name and below your shop name, you can find one link. E.g. <i>betterspace-dev.myshopify.com</i>`,
                image: shopDomain,
            },
        ],
    },
    { text: `Now please copy that URL and paste it into the provided text box in the Betterspace Supplier Dashboard.`, initialValues },
]
